import { Component, OnInit } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';
import { SearchService } from '@services/search.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfigService } from '@services/config.service';
import { CoupleIdLite } from '@shared/models/generic/id/couple-id-lite.model';
import { SearchPayload } from '@shared/models/search.model';
import { ReleaseDialogComponent } from '../releaseNote/dialog/release-dialog.component';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-release-note-button',
  templateUrl: './release-note-button.component.html',
  styleUrls: ['./release-note-button.component.scss'],
  imports: [NgIf, CommonModule, SharedModule],
})
export class ReleaseNoteButtonComponent implements OnInit {
  latestReleases: CoupleIdLite[] = [];
  hasNewRelease = false;
  latestReleaseDate?: string;

  private readonly LATEST_RELEASE_DATE = 'latestReleaseDate';
  private readonly FRENCH_VALIDATED_KEY = '51 27 3D 37 2D 2F 01 81 8D 01 9F C0 01 8F 0A 00¤¤VALIDATED¤¤Validé';
  private readonly ENGLISH_VALIDATED_KEY = '51 27 3D 37 2D 27 4D 2F 2D 01 0D 01 9F F0 01 8F 0C 00¤¤VALIDATED¤¤Validated';

  constructor(
    private readonly searchService: SearchService,
    private readonly dialog: MatDialog,
    private readonly configService: ConfigService,
  ) {}

  ngOnInit(): void {
    this.fetchLatestReleases();
  }

  fetchLatestReleases(): void {
    const lang = this.configService.currentLanguage;
    const market = lang === 'fr' ? 'GS_FR' : 'GS_INT';
    const validatedKey = lang === 'fr' ? this.FRENCH_VALIDATED_KEY : this.ENGLISH_VALIDATED_KEY;

    const params = this.buildSearchPayload(market, validatedKey);

    this.searchService.searchContents(params, '', 20, 0, '', lang, market).subscribe((releasesSearch) => {
      if (releasesSearch?.content?.length) {
        const searchContents = releasesSearch.content;
        this.latestReleaseDate = searchContents[0].publicationStartDate ?? '';
        const sameDateReleases = searchContents
          .filter((r) => r.publicationStartDate === this.latestReleaseDate)
          .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

        this.latestReleases = sameDateReleases.map((r) => r.identifier);
        const seenPublicationDate = localStorage.getItem(this.LATEST_RELEASE_DATE);
        this.hasNewRelease = !seenPublicationDate || new Date(this.latestReleaseDate) > new Date(seenPublicationDate);
      }
    });
  }

  async onLatestReleaseClick(): Promise<void> {
    if (!this.latestReleases.length) {
      return;
    }

    this.dialog.open(ReleaseDialogComponent, {
      data: this.latestReleases,
      width: '900px',
      maxHeight: '90vh',
    });

    this.hasNewRelease = false;
    if (this.latestReleaseDate) {
      localStorage.setItem(this.LATEST_RELEASE_DATE, this.latestReleaseDate);
    }
  }

  private buildSearchPayload(market: string, validatedKey: string): SearchPayload {
    return {
      fieldList: ['id', 'order', 'publicationStartDate'],
      fieldFilters: [
        { field: 'domain.key', values: ['DCP_DCP'] },
        { field: 'supertype.key', values: ['NEWS'] },
        { field: 'type.key', values: ['RELEASE'] },
        { field: 'market.key', values: [market] },
      ],
      sort: {
        name: 'publicationStartDate',
        direction: 'DESC',
      },
      facetFilters: [
        {
          facet: 'status',
          key: validatedKey,
          value: '',
          type: 'inclusion',
        },
      ],
    };
  }
}
